module.exports = __webpack_public_path__ + "img/arbitrum.65f444f0.svg";